import { APP_CONFIG } from '../constants/global-variables.js';

export async function getLeagues(countryId) {
    const url = `${APP_CONFIG.URL.apiBasePath}ajax/leagues/${countryId}`;

    try {
        const res = await axios.get(url, {
            headers: {
              "Content-Type": "application/json",
            },
          });
          
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}
